import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import BrandMark from "./BrandMark";
import { SUPPORT_EMAIL } from "./SupportCard";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-white/5" data-testid="site-footer">
      <div className="max-w-[1800px] mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 text-sm">
        <div className="lg:col-span-1 md:col-span-2">
          <BrandMark size={32} />
          <p className="mt-4 text-white/50 max-w-sm leading-relaxed">
            A premium scanner for stocks, ETFs, futures and micro futures.
            Designed for traders who care about clean setups and fast signals.
          </p>
        </div>
        <div>
          <div className="label-mono mb-3">Product</div>
          <ul className="space-y-1.5 text-white/60">
            <li><Link to="/dashboard" className="hover:text-white transition-colors" data-testid="footer-link-scanner">Scanner</Link></li>
            <li><Link to="/pricing" className="hover:text-white transition-colors" data-testid="footer-link-pricing">Pricing</Link></li>
            <li><Link to="/profile" className="hover:text-white transition-colors" data-testid="footer-link-account">Account</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-mono mb-3">Support</div>
          <ul className="space-y-1.5 text-white/60">
            <li>
              <Link to="/support" className="hover:text-white transition-colors" data-testid="footer-link-support">
                Help &amp; Contact
              </Link>
            </li>
            <li>
              <a
                href={`mailto:${SUPPORT_EMAIL}?subject=FlowFinder%20support%20request`}
                className="inline-flex items-center gap-1.5 hover:text-[var(--bull)] transition-colors font-mono text-[12px]"
                data-testid="footer-support-email"
              >
                <Mail className="w-3 h-3" />
                {SUPPORT_EMAIL}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="label-mono mb-3">Legal</div>
          <ul className="space-y-1.5 text-white/60">
            <li><Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-link-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-mono mb-3">Disclaimer</div>
          <p className="text-white/50 text-xs leading-relaxed" data-testid="disclaimer-footer">
            Educational purposes only. Not financial advice. Market data may be delayed depending on provider.
            Trading involves substantial risk of loss. Past performance does not guarantee future results.
          </p>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-white/30 font-mono tracking-wider">
        © 2026 FLOWFINDER · ALL SIGNALS ARE EDUCATIONAL
      </div>
    </footer>
  );
}
